import { render, staticRenderFns } from "./datagrid.vue?vue&type=template&id=f5f68efe&"
import script from "./datagrid.vue?vue&type=script&lang=js&"
export * from "./datagrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/datagrid.vue"
export default component.exports